// Utility functions for managing JSON files in localStorage

const STORAGE_KEY = 'canon_json_files';

export const saveJsonFile = (name, jsonContent) => {
    try {
        const existingFiles = getSavedFiles();
        const newFile = {
            id: Date.now().toString(),
            name: name.trim(),
            content: jsonContent,
            createdAt: new Date().toISOString()
        };

        existingFiles.push(newFile);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(existingFiles));
        return { success: true, file: newFile };
    } catch (error) {
        console.error('Error saving file:', error);
        return { success: false, error: error.message };
    }
};

export const getSavedFiles = () => {
    try {
        const files = localStorage.getItem(STORAGE_KEY);
        return files ? JSON.parse(files) : [];
    } catch (error) {
        console.error('Error loading files:', error);
        return [];
    }
};

export const loadJsonFile = (fileId) => {
    try {
        const files = getSavedFiles();
        const file = files.find(f => f.id === fileId);
        return file ? { success: true, file } : { success: false, error: 'File not found' };
    } catch (error) {
        console.error('Error loading file:', error);
        return { success: false, error: error.message };
    }
};

export const deleteJsonFile = (fileId) => {
    try {
        const files = getSavedFiles();
        const filteredFiles = files.filter(f => f.id !== fileId);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredFiles));
        return { success: true };
    } catch (error) {
        console.error('Error deleting file:', error);
        return { success: false, error: error.message };
    }
};

export const isFileNameUnique = (name, excludeId = null) => {
    const files = getSavedFiles();
    return !files.some(f => f.name.toLowerCase() === name.toLowerCase() && f.id !== excludeId);
};
